module.exports = __webpack_public_path__ + "img/disableshared.b9f7f2b8.svg";